import React, { Component } from 'react'

export default class TagsHolder extends Component {
    render() {
        const { children, style = {} } = this.props;
        const newStyle = {...styles.tagsHolder, ...style};
        return (
            <div style={newStyle}>
                {children}
            </div>
        )
    }
}

const styles = {
    tagsHolder: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-evenly",
        flexFlow: "wrap",
    }
}